import styled, { css } from "styled-components";

import { onBackgroundImage } from "components/common/backgroundFrame";
import { CSS_VARIABLES } from "enums/cssVariables";
import { customizationBackgroundToCssVariable } from "services/customizationService";

import type { PageBackgroundProps } from "types/customizationType";

// Light scrim over the image, keeping the dark default text readable on dark or busy images.
const BACKGROUND_SCRIM =
    "linear-gradient(rgb(255 255 255 / 20%), rgb(255 255 255 / 20%))";

const PageBackground = ({ customizationBackground }: PageBackgroundProps) => {
    const imageCssVariable =
        customizationBackgroundToCssVariable[customizationBackground];

    return (
        <BackgroundLayer
            aria-hidden="true"
            data-customization-background={customizationBackground}
            $imageCssVariable={imageCssVariable}
        />
    );
};

// Fixed to the viewport: the Layout column is capped at 620px, an absolute layer would leave white side gutters on wide screens.
const BackgroundLayer = styled.div<{ $imageCssVariable: CSS_VARIABLES }>`
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background-image: var(${(props) => props.$imageCssVariable}, none);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    ${onBackgroundImage(css<{ $imageCssVariable: CSS_VARIABLES }>`
        background-image:
            ${BACKGROUND_SCRIM}, var(${(props) => props.$imageCssVariable});
    `)}
`;

export default PageBackground;
